<div *ngIf="mostrarContenido">
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
  <notifier-container></notifier-container>
  <router-outlet></router-outlet>
</div>

<div *ngIf="!mostrarContenido" class="home-wrapper">
  <!-- HERO -->
  <div  class="hero">
    <!-- Columna izquierda: Imagen -->
    <div id="mth_empresas__banner-inicio-session" class="hero__left">
      <img *ngIf="isMobile"
           src="assets/images/home-portalempresas-mobile.webp"
           class="hero__img"
           alt="Portal transaccional empresarial" />
      <img *ngIf="!isMobile"
           src="assets/images/home-portalempresas-desktop.webp"
           class="hero__img"
           alt="Portal transaccional empresarial" />
    </div>

    <!-- Columna derecha -->
    <div class="hero__right">
      <h2 class="title-wrapper-desktop" *ngIf="!isMobile">Accede y gestiona la información</h2>
      <h2 class="title-wrapper-mobile" *ngIf="isMobile">Accede y gestiona la información</h2>

      <p>Consulta y administra los datos de tu empresa cuando lo necesites, de manera fácil.</p>

      <ul class="hero__list">
        <li>¿Ya tienes cuenta?
            <a target="blank" href="https://cms.colsubsidio.com/sites/default/files/Documentos/colsubsidio/portal-transaccional-empresas-colsubsidio-ya-tienes-cuenta.pdf" class="link">Consulta cómo iniciar sesión</a>.
        </li>
        <li>¿Olvidaste tu contraseña?
            Recupérala en pocos pasos  
            <a target="blank" href="https://cms.colsubsidio.com/sites/default/files/Documentos/colsubsidio/portal-transaccional-empresas-colsubsidio-contrasena.pdf" class="link">en esta guía</a>.
        </li>
        <li>¿Necesitas actualizar tu correo?
            <a target="blank" href="https://cms.colsubsidio.com/sites/default/files/Documentos/colsubsidio/portal-transaccional-empresas-colsubsidio-actualizar-correo.pdf" class="link">Cámbialo siguiendo nuestras instrucciones</a>.
        </li>
        <li>¿Quieres administrar tus usuarios del portal empresas?  
            <a target="blank" href="https://cms.colsubsidio.com/sites/default/files/Documentos/colsubsidio/portal-transaccional-empresas-colsubsidio-gestionar-usuarios.pdf" class="link">Con esta guía</a>
            podrás realizarlo.
        </li>
      </ul>

      <!-- Recuadro video -->
      <div class="video-box">
        <a href="https://www.youtube.com/watch?v=qMjIN9EX2JM"
           target="_blank"
           class="video-box__link">
          Consulta el video para conocer los nuevos métodos de autenticación
        </a>
      </div>

      <!-- Mensaje final -->
      <p class="final-message">
        Juntos lo <strong>hacemos posible</strong>
      </p>

      <!-- Pie de página -->
      <div class="footnote">
        <span class="footnote__logo">
          <img src="assets/images/Supersubsidio.png"
               alt="Vigilado Supersubsidio" />
        </span>
        <span class="footnote__text">
          Todos los derechos reservados © Colsubsidio {{ currentYear }}
        </span>
      </div>
    </div>
  </div>
</div>